import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { CmsTokenObject } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type FetchCMSTokens = "FETCH_CMS_TOKENS";
export const FETCH_CMS_TOKENS: FetchCMSTokens = "FETCH_CMS_TOKENS";
export type FetchCMSTokensEnd = "FETCH_CMS_TOKENS_END";
export const FETCH_CMS_TOKENS_END: FetchCMSTokensEnd = "FETCH_CMS_TOKENS_END";

export interface FetchCMSTokensAction extends Action {
    type: FetchCMSTokens;
    payload: {
        appId: string;
        credentials: Credentials;
    };
}

export interface FetchCMSTokensEndAction extends Action {
    type: FetchCMSTokensEnd;
    payload: {
        appId: string;
        error?: Error;
        tokens?: CmsTokenObject[];
    };
}

export function fetchCMSTokens(appId: string): ThunkAction<void, State, undefined, FetchCMSTokensAction> {
    return (dispatch: Dispatch<FetchCMSTokensAction>, getState) => {
        const credentials = getState().auth.credentials;

        dispatch(fetchCMSTokensWithCredentials(appId, credentials));
    };
}

export function fetchCMSTokensWithCredentials(appId: string, credentials: Credentials): FetchCMSTokensAction {
    return {
        payload: {
            appId,
            credentials
        },
        type: FETCH_CMS_TOKENS
    };
}

export function fetchCMSTokensEnd(appId: string, error?: Error, tokens?: CmsTokenObject[]): FetchCMSTokensEndAction {
    return {
        payload: {
            appId,
            error,
            tokens
        },
        type: FETCH_CMS_TOKENS_END
    };
}
